import {
	PHARMACY_TIMEOFF_LIST_REQUEST,
	PHARMACY_TIMEOFF_LIST_SUCCESS,
	PHARMACY_TIMEOFF_LIST_FAILURE
} from "../../constants";

const initialState = {
	data: [],
	loading: false,
	error: null,
};

const pharmacyTimeOffListsReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_TIMEOFF_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: []
			};
		case PHARMACY_TIMEOFF_LIST_SUCCESS:
			return {
				...state,
				data: action.payload,
				loading: false,
				error: null,
			};
		case PHARMACY_TIMEOFF_LIST_FAILURE:
			return {
				...state,
				data: [],
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export default pharmacyTimeOffListsReducer;
